import { useEffect, useState } from 'react'
import { ImageSize } from '../model/readiness'

/**
 * Measures a stored image by loading it in the browser. Google refuses photos
 * under 1024 px, and the stored URL does not carry a size, so the readiness
 * check needs the real pixels. `null` while loading or when the image cannot
 * be read.
 */
export function useImageSize(url: string): ImageSize | null {
    const [size, setSize] = useState<ImageSize | null>(null)

    useEffect(() => {
        if (!url) {
            setSize(null)
            return
        }
        let cancelled = false
        const image = new Image()
        image.onload = () => {
            if (!cancelled) setSize({ width: image.naturalWidth, height: image.naturalHeight })
        }
        image.onerror = () => {
            if (!cancelled) setSize(null)
        }
        image.src = url
        return () => {
            cancelled = true
        }
    }, [url])

    return size
}
